package nl.astraeus.midi.symbols

import kotlinx.browser.document
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement

fun createCanvasCtx(
  width: Int = 100,
  height: Int = 200,
  lineWidth: Double = 3.0
): Pair<HTMLCanvasElement, CanvasRenderingContext2D> {
  val canvas = document.createElement("canvas") as HTMLCanvasElement
  val ctx = canvas.getContext("2d") as CanvasRenderingContext2D

  canvas.width = width
  canvas.height = height

  ctx.clearRect(0.0, 0.0, canvas.width.toDouble(), canvas.height.toDouble())

  ctx.fillStyle = "black"
  ctx.strokeStyle = "black"
  ctx.lineWidth = lineWidth

  return canvas to ctx
}